const FontWeights = {
  headerWeight: 400,
  textWeight: 300,
  subtextWeight: 200,
}

export default FontWeights
